/**
 * This API enables cross-origin requests to anywhere.
 * @type {string}
 */
const corsAnywhere = process.env.REACT_APP_CORS_ANYWHERE ;

export default corsAnywhere ;
